import { css } from "@emotion/react";

export const fontFaces = css`
    /* === Canela === */
    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-Thin.woff2") format("woff2");
        font-weight: 100;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-ThinItalic.woff2") format("woff2");
        font-weight: 100;
        font-style: italic;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-Light.woff2") format("woff2");
        font-weight: 200;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-LightItalic.woff2") format("woff2");
        font-weight: 200;
        font-style: italic;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-Regular.woff2") format("woff2");
        font-weight: 400;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-RegularItalic.woff2") format("woff2");
        font-weight: 400;
        font-style: italic;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-Medium.woff2") format("woff2");
        font-weight: 500;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-MediumItalic.woff2") format("woff2");
        font-weight: 500;
        font-style: italic;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-Bold.woff2") format("woff2");
        font-weight: 700;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-BoldItalic.woff2") format("woff2");
        font-weight: 700;
        font-style: italic;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-Black.woff2") format("woff2");
        font-weight: 900;
    }

    @font-face {
        font-family: "Canela";
        font-display: fallback;
        src: url("/Fonts/Canela/Canela-BlackItalic.woff2") format("woff2");
        font-weight: 900;
        font-style: italic;
    }

    /* === Inter === */
    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-100.woff2") format("woff2");
        font-weight: 100;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-100italic.woff2") format("woff2");
        font-weight: 100;
        font-style: italic;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-200.woff2") format("woff2");
        font-weight: 200;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-200italic.woff2") format("woff2");
        font-weight: 200;
        font-style: italic;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-regular.woff2") format("woff2");
        font-weight: 400;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-italic.woff2") format("woff2");
        font-weight: 400;
        font-style: italic;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-500.woff2") format("woff2");
        font-weight: 500;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-500italic.woff2") format("woff2");
        font-weight: 500;
        font-style: italic;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-600.woff2") format("woff2");
        font-weight: 600;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-600italic.woff2") format("woff2");
        font-weight: 600;
        font-style: italic;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-700.woff2") format("woff2");
        font-weight: 700;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-700italic.woff2") format("woff2");
        font-weight: 700;
        font-style: italic;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-900.woff2") format("woff2");
        font-weight: 900;
    }

    @font-face {
        font-family: "Inter";
        font-display: swap;
        src: url("/Fonts/Inter/inter-v18-latin_latin-900italic.woff2") format("woff2");
        font-weight: 900;
        font-style: italic;
    }
`;
